// This file is generated by the 'generate.js' script. Any changes made to this file will be overwritten.
import { Component, Prop, State, Watch, Host, h, getAssetPath } from '@stencil/core';

@Component({
  tag: 'som-icon',
  styleUrl: '../../sass/components/_icon.scss',
  shadow: true,
})
export class SomIcon {
  
  /*************
   * PROPERTIES
   **************/

  /**
   * The name of the icon
   */
  @Prop({reflect: true}) name: string;
  @Watch('name')
  handleName() {
    this.getIconData();
  }

  /**
   * This property represents the color of the icon. By default, the color will match the current font color. However, you can override this color by passing in the name of SASS variable (`primary`, `secondary`, `success`, `danger`, `warning`, `light`, `dark`, `black`, `white`, `dark-gray`, `light-gray`, `body-copy`).
   */
  @Prop() color: string;

  /**
   * This property represents the size of the icon. By default, the size will be determined by the current font size. However, you can override this size using pre-built sizes (`sm`, `md`, `lg`, `xl`).
   */
  @Prop() size: string;

  /**
   * This property represents the CSS display property. In certain circumstances you may need to adjust the display property to properly align the icon. 
   */
  @Prop() display: string = 'inline-block';

  /*************
   * STATE VARIABLES
   **************/

  @State() iconData;


  /*************
   * LIFECYCLE EVENTS
   **************/
  componentWillLoad() {
    this.getIconData();
  }


  /*************
   * LOCAL METHODS
   **************/
  async getIconData() {
    const res = await fetch(getAssetPath(`assets/icons/${this.name}.svg`));
    if (res.status === 200) {
      this.iconData = await res.text();    
    } else {
      console.error(`Error fetching icon - ${this.name}`);
    }    
  }

  render() {
    return (
      <Host class={'som-icon-container' + (this.display ? ' som-icon-display-' + this.display : '')}>
        <div
          class={'som-icon' + (this.size ? ' som-icon-size-' + this.size : '') + (this.color ? ' som-icon-color-' + this.color : '') + (this.display ? ' som-icon-display-' + this.display : '')}
          innerHTML={this.iconData}
        />
      </Host>
    );
  }
}
